<template>
  <div id="memorial-security">
    <h2>{{ $t('pages.memorial.security') }}</h2>
    <b-container>
      <div class="private">
        <toggle-button
          :width="80"
          :height="30"
          :value="isPrivate"
          :color="{ checked: '#7DCE94', unchecked: '#82C7EB' }"
          :sync="true"
          :labels="{ checked: $t('form.private'), unchecked: $t('form.public') }"
          @change="onChangeTogglePrivate"
        />
      </div>
      <ajax-edit
        :name="name"
        :uri="uri"
        :id="id"
        :additionnal-route="additionnalRoute"
        :form-class="isPrivate ? 'show-password' : 'hidden-password'"
        :config="{ headers: { 'Content-Language': $translation.getLocale() } }"
        :form-id="`${name}-security`"
      />
    </b-container>
  </div>
</template>

<script>
  import AjaxEdit from '@triotech/vue-core/src/components/ajax/AjaxEdit';

  export default {
    name: 'MemorialSecurity',
    components: {
      AjaxEdit,
    },
    props: {
      isPrivate: {
        type: [Boolean],
        default: false,
      },
    },
    data() {
      return {
        id: this.user().memorial.id,
        name: 'memorial',
        uri: 'api/memorial',
        additionnalRoute: 'security',
        currentPassword: null,
      };
    },
    mounted() {
      if (!this.user().memorial.currency) {
        this.$bus.$once(`t-event.edit-submit.${this.name}.success`, () => {
          this.$ajax.refresh().then(() => {
            this.$parent.step += 1;
          });
        });
      }
    },
    methods: {
      onChangeTogglePrivate() {
        if (this.isPrivate) {
          // eslint-disable-next-line no-underscore-dangle
          this.currentPassword = this.$children[1]._data.model.private_password;
          // eslint-disable-next-line no-underscore-dangle
          this.$set(this.$children[1]._data.model, 'private_password', null);
        } else {
          // eslint-disable-next-line no-underscore-dangle
          this.$set(this.$children[1]._data.model, 'private_password', this.currentPassword);
        }
        this.$bus.$emit('t-event.change-private');
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
  @import '~@triotech/vue-core/src/scss/compass';
  @import 'compass/css3/transform';

  #memorial-security {
    .private {
      /deep/ label.vue-js-switch {
        .v-switch-core {
          box-shadow: inset 0 1px 2px rgba(0,0,0,.15), inset 0 0 3px rgba(0,0,0,.2);

          .v-switch-button {
            width: 28px !important;
            height: 28px !important;
            box-shadow: -1px 1px 5px rgba(0,0,0,.2);
            background: linear-gradient(180deg,#fff 40%,#f0f0f0);
            @include transform(translate(1px, 1px)!important);

            &::before {
              content: "";
              position: absolute;
              top: 50%;
              left: 50%;
              margin: -6px 0 0 -6px;
              width: 12px;
              height: 12px;
              background: linear-gradient(180deg,#eee,#fff);
              border-radius: 6px;
              box-shadow: inset 0 1px rgba(0,0,0,.02);
            }
          }
        }

        span.v-switch-label {
          text-transform: uppercase;
        }

        &.toggled {
          .v-switch-core {
            .v-switch-button {
              @include transform(translate(51px, 1px)!important);
            }
          }
        }
      }
    }

    /deep/ form {
      .hidden-password {
        .field-input {
          display: none;
        }
      }

      .show-password {
        .field-input {
          display: block;
        }
      }

      .field-switch {
        .field-wrap {
          label {
            width: 80px;
          }
        }
        input:checked ~ .label {
          background-color: #7DCE94;
        }
        input:checked ~ .handle {
          left: 51px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Memorial/security.vue